/**
 * Read dev-simulator state from storage and return the corresponding
 * request headers.  Per-tab override (sessionStorage ``dev-simulator-tab``)
 * takes precedence over the global value (localStorage ``dev-simulator``).
 *
 * Returns an empty object in production mode or when no simulation is active.
 */
export function getDevSimulatorHeaders(): Record<string, string> {
    if (import.meta.env.VITE_MODE === 'production') {
        return {}
    }

    try {
        const raw =
            sessionStorage.getItem('dev-simulator-tab') ||
            localStorage.getItem('dev-simulator')
        if (!raw) return {}

        const sim = JSON.parse(raw)
        const headers: Record<string, string> = {}

        if (sim.user) {
            headers['X-Dev-Simulate-User'] = sim.user
        }
        if (sim.roles && sim.roles.length > 0) {
            headers['X-Dev-Simulate-Roles'] = sim.roles.join(',')
        }
        if (sim.services && sim.services.length > 0) {
            headers['X-Dev-Simulate-Services'] = sim.services.join(',')
        }
        return headers
    } catch {
        return {}
    }
}
